"use client";

import { c as _c } from "react/compiler-runtime";
import { SectionBoundary } from "@/features/home-v2/states/SectionBoundary";
import JournalComments from "@/features/comments/components/JournalComments";
import AuctionBoard from "../AuctionBoard";
import { AuctionDetails, AuctionOwnerPanel, AuctionResults, AuctionStory } from "../AuctionFacts";
import type { Ctx } from "./parts";
function Board(t0) {
  const $ = _c(9);
  const {
    auction,
    p,
    lang
  } = t0;
  const isFa = lang === "fa";
  const t1 = isFa ? "\u0641\u0647\u0631\u0633\u062A \u067E\u06CC\u0634\u0646\u0647\u0627\u062F\u0647\u0627 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u0646\u0634\u062F" : "The bids didn't load";
  const t2 = isFa ? "\u0628\u0642\u06CC\u0647\u200C\u06CC \u0627\u06CC\u0646 \u0635\u0641\u062D\u0647 \u0633\u0627\u0644\u0645 \u0627\u0633\u062A." : "The rest of this page is fine.";
  const t3 = isFa ? "\u062A\u0644\u0627\u0634 \u0645\u062C\u062F\u062F" : "Try again";
  let t4;
  if ($[0] !== auction || $[1] !== lang || $[2] !== p) {
    t4 = <AuctionBoard auction={auction} p={p} lang={lang} />;
    $[0] = auction;
    $[1] = lang;
    $[2] = p;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t4) {
    t5 = <SectionBoundary title={t1} description={t2} retryLabel={t3}>{t4}</SectionBoundary>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function Talk(t0) {
  const $ = _c(3);
  const {
    auction,
    lang
  } = t0;
  let t1;
  if ($[0] !== auction.id || $[1] !== lang) {
    t1 = <JournalComments modelId={auction.id} modelType="auction" lang={lang} />;
    $[0] = auction.id;
    $[1] = lang;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/**
 * THE FILE under every design: one framed panel family (the comments' own
 * frame) in two columns — the bids and the talk in the reading column; the
 * owner's tools, the work's record and its note at the side — so no column
 * is left half empty and no section wears a ground of its own.
 */
export function Book(c) {
  const $ = _c(35);
  const {
    auction,
    p,
    lang,
    description,
    className: t0
  } = c;
  const className = t0 === undefined ? "" : t0;
  let t1;
  if ($[0] !== lang || $[1] !== p.dismiss || $[2] !== p.records) {
    t1 = <AuctionResults records={p.records} onDismiss={p.dismiss} lang={lang} />;
    $[0] = lang;
    $[1] = p.dismiss;
    $[2] = p.records;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `ap-book ${className}`;
  let t3;
  if ($[4] !== c) {
    t3 = <div className="ap-slot ap-slot--bids"><Board {...c} /></div>;
    $[4] = c;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== c) {
    t4 = <div className="ap-slot ap-slot--talk"><Talk {...c} /></div>;
    $[6] = c;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="ap-col">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== auction || $[12] !== lang || $[13] !== p.canCancel || $[14] !== p.canDelete || $[15] !== p.canEdit) {
    t6 = <div className="ap-slot ap-slot--owner"><AuctionOwnerPanel auction={auction} canEdit={p.canEdit} canCancel={p.canCancel} canDelete={p.canDelete} lang={lang} /></div>;
    $[11] = auction;
    $[12] = lang;
    $[13] = p.canCancel;
    $[14] = p.canDelete;
    $[15] = p.canEdit;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== auction || $[18] !== lang || $[19] !== p.bids.length) {
    t7 = <div className="ap-slot ap-slot--record"><AuctionDetails auction={auction} bidsCount={p.bids.length} lang={lang} fold="open" /></div>;
    $[17] = auction;
    $[18] = lang;
    $[19] = p.bids.length;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== description || $[22] !== lang) {
    t8 = description ? <div className="ap-slot ap-slot--note"><AuctionStory text={description} lang={lang} fold="closed" /></div> : null;
    $[21] = description;
    $[22] = lang;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = <aside className="ap-aside">{t6}{t7}{t8}</aside>;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t2 || $[29] !== t5 || $[30] !== t9) {
    t10 = <div className={t2}>{t5}{t9}</div>;
    $[28] = t2;
    $[29] = t5;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== t1 || $[33] !== t10) {
    t11 = <>{t1}{t10}</>;
    $[32] = t1;
    $[33] = t10;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  return t11;
}